import { render, staticRenderFns } from "./designer.vue?vue&type=template&id=64bac7e3&"
import script from "./designer.vue?vue&type=script&lang=js&"
export * from "./designer.vue?vue&type=script&lang=js&"
import style0 from "./designer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports